<template>
  <div class="box">
    <div class="header">
      <div class="title">分润余额(元)</div>
      <div class="price">{{ this.balance }}</div>
    </div>
    <div class="content" ref="container">
      <van-notice-bar color="#ffa347" background="#ecf9ff" left-icon="info-o">如需提现，请使用电脑端</van-notice-bar>
      <van-sticky @scroll="stickyChange" :class="stickyChangeFlag ? 'stickyBottom' : ''" :offset-top="offsetTop" :container="container">
        <div class="list bc">
          <h3>{{ nowTime }}</h3>
          <div class="icons">
            <van-icon name="notes-o" @click="showPicker = true" />
            <van-icon name="replay" @click="replay" />
          </div>
        </div>
      </van-sticky>
      <VANABS :list= list :paramsList=paramsList @change="changlist"></VANABS>
    </div>
    <van-popup round  v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm= "onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import VANABS from '@/components/BalanceVanTab'
import { profit, profitList } from '@/api/user.js'
export default {
  components: { VANABS },
  props: {},
  data () {
    return {
      show: false,
      date: '',
      nowTime: '2021年6月',
      showPicker: false,
      currentDate: new Date(),
      balance: '',
      paramsList: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        createTime: ''
      },
      list: [],
      stickyChangeFlag: false,
      container: null,
      offsetTop: '0'
    }
  },
  watch: {},
  computed: {
    minDate: function () {
      const time = new Date().getTime()
      const minTime = (time - 1000 * 60 * 60 * 24 * 30 * 5) * 1
      return new Date(minTime)
    },
    maxDate: function () {
      return new Date()
    }
  },
  methods: {
    // 重置时间查询
    replay () {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否重置查询时间'
      }).then(async () => {
        window.scrollTo(0, 0)
        this.paramsList.createTime = ''
        this.paramsList.page = 1
        this.nowTime = new Date().getFullYear() + '年' + (new Date().getMonth() * 1 + 1) + '月' + new Date().getDate() + '日'
        const { data: res } = await profitList(this.paramsList)
        if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
          this.$router.push('/login')
          this.$toast.fail('请重新登录')
        }
        // res.extend.rows.forEach(item => {
        //   item.createTime = item.createTime.split('T')[0] + ' ' + item.createTime.split('T')[1].split('.')[0]
        // })
        this.list = res.extend.rows
        if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
          // 更新获取下一次数据的时间戳
          this.paramsList.page++
        }
        // on close
      }).catch(() => {
        this.$toast('取消重置')
      })
    },
    formatDate (date) {
      return `${date.getFullYear()}年 ${date.getMonth() + 1}月 ${date.getDate()}月`
    },
    async onConfirm (date) {
      window.scrollTo(0, 0)
      this.showPicker = false
      this.nowTime = this.formatDate(date)
      this.paramsList.page = 1
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const days = year + '-' + month + '-' + day
      this.paramsList.createTime = days
      const { data: res } = await profitList(this.paramsList)
      // res.extend.rows.forEach(item => {
      //   item.createTime = item.createTime.split('T')[0] + ' ' + item.createTime.split('T')[1].split('.')[0]
      // })
      this.list = res.extend.rows
      if (res.extend.rows && res.extend.rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      }
    },
    async profit () {
      const { data: res } = await profit({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      this.balance = res.balance
    },
    changlist (e) {
      if (e.type === 'add') {
        this.list.push(...e.list)
      } else {
        this.list = []
      }
    },
    stickyChange (e) { this.stickyChangeFlag = e.isFixed }
  },
  beforeCreate () {},
  created () {
    this.profit()
    this.nowTime = new Date().getFullYear() + '年' + (new Date().getMonth() + 1) + '月' + new Date().getDate() + '日'
  },
  mounted () {
    this.container = this.$refs.container
  }
}
</script>

<style scoped lang='less'>
  .box {
    height: 100%;
    box-sizing: border-box;
  }
  .header {
    height: 20vh;
    background-color: red;
    background: url(../../../../assets/benefit-ban-balance.png) no-repeat;
    background-size: 100% 100%;
    text-align: center;
    color: #fff;
    .title {
      font-size: 35px;
      padding-top: 60px;
      padding-bottom: 20px;
    }
    .price {
      font-size: 55px;
    }
  }
  .content {
    margin-top: -35px;
    background-color: #fff;
    border-radius: 25px;
    overflow: hidden;
    .bc {
      padding: 0 35px;
    }
    /deep/.van-notice-bar {
      width: 100vw;
    }
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      h3 {
        font-size: 35px;
      }
      .icons {
        width: 150px;
        display: flex;
        justify-content: space-around;
      }
    }
  }
  .bc {
    margin-bottom: 25px;
    font-size: 45px;
  }
  .stickyBottom {
    .list {
      background-color: #ffa347!important;
      color: #fff;
      height: 100px;
    }
  }
</style>
